import Loadable from 'UIComponents/decorators/Loadable';
const AsyncConnectedMessageComposerAlertTray = Loadable({
  loader: () => import( /* webpackChunkName: "connected-message-composer-alert-tray" */'conversations-thread-view/alerts/components/MessageComposerAlertTray'),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncConnectedMessageComposerAlertTray;